module.exports = __webpack_public_path__ + "img/order_not.png?v=a7106559";